/**
 * Redux subtree key for the participants-layout feature.
 */
export const STORE_NAME = 'features/participants-layout';
/**
 * The DOM attribute (on <html>) that carries the active participants layout, so
 * the themed CSS can key off it (mirrors `data-theme`).
 */
export const LAYOUT_DOM_ATTR = 'data-participants-layout';
/**
 * Selectable participant-display layouts. Values match the demo mockups in
 * `public/demo/participants/`. Shown in Settings → その他 (like the theme picker).
 */
export const PARTICIPANTS_LAYOUTS = [
    { value: 'none', label: '表示なし（AIのみ）' },
    { value: 'role-sections', label: 'AI / 参加者 分割' },
    { value: 'speaker-strip', label: '話者大＋サムネ列' },
    { value: 'grid', label: '均等グリッド' },
    { value: 'ai-main', label: 'AIメイン＋ユーザー小' },
    { value: 'sidebar', label: 'サイドバー一覧' },
    { value: 'conversation', label: '1:1 対面' },
    { value: 'pip', label: 'フローティングPiP' },
    { value: 'carousel', label: '横スライド' },
    { value: 'coverflow', label: '中央スライド' }
];
/**
 * Default layout — minimal (AI only), per product decision.
 */
export const DEFAULT_PARTICIPANTS_LAYOUT = 'none';
